// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2MJjf","buttons":"SendReceipts_buttons__3R0Rt","email":"SendReceipts_email__3eank","bookApptTitle":"SendReceipts_bookApptTitle__1XxoF"};